// Decodes (not verifies) a JWT payload to read claims like email. Signature
// verification of the Google credential belongs server-side, in the future
// Apps Script endpoint (Handoff §2) — this is just enough to drive the UI.
export function decodeJwtPayload(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const json = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
      .join('')
  );
  return JSON.parse(json);
}
